export const config = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://backend.ddev.site/api',
  environment: process.env.REACT_APP_ENVIRONMENT || 'development',
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
};

export default config;
